import Bus from '../Bus'

const Loading = {
    watch: {
        loading(value) {
            Bus.$emit('loading', value)
        }
    },
    data() {
        return {
            loading: false
        }
    }
}

export default Loading


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Loading.js